import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRuleField,
  IIntegrationRuleAutomationField,
  IIntegrationRuleField,
} from "../models/integration-rule-field";

const INTEGRATION_RULE_FIELD_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleField/";

const SOFTWARE_SELECTOR_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/Software/All/list";

const INTEGRATION_RULE_FIELD_SOFTWARE_CODES = ["17", "31", "32", "33"];

export const createIntegrationRuleField = (item: INewIntegrationRuleField) => {
  return GlobalAxios.post(INTEGRATION_RULE_FIELD_ROUTE, item);
};

export const getIntegrationRuleFieldById = (id: string) => {
  return GlobalAxios.get<IIntegrationRuleField>(
    INTEGRATION_RULE_FIELD_ROUTE + id,
  );
};

export const updateIntegrationRuleFieldById = ({
  item,
  id,
}: {
  item: INewIntegrationRuleField;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_FIELD_ROUTE + id, item);
};

export const automationFieldList = (params?: any) => {
  return GlobalAxios.get<IIntegrationRuleAutomationField[]>(
    INTEGRATION_RULE_FIELD_ROUTE + "automation-fields",
    {
      params,
      paramsSerializer: { indexes: null },
    },
  ).then((response) => ({
    ...response,
    data: response.data.map(
      (item) =>
        ({
          ...item.automationField,
          id: item.automationFieldId,
        }) as ISelectType,
    ),
  }));
};

export const softwareListForIntegrationRuleFields = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(SOFTWARE_SELECTOR_ROUTE, {
    params: {
      ...params,
      softwareCodes: INTEGRATION_RULE_FIELD_SOFTWARE_CODES,
    },
    paramsSerializer: { indexes: null },
  });
};
